<template>
  <b-modal
    id="global-modal"
    v-model="show"
    hide-footer
    hide-header
    centered
    :size="size"
    @hidden="onHidden"
  >
    <component :is="component" v-bind="props" />
  </b-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('modal', ['component', 'props', 'size']),
    show: {
      get() {
        return this.$store.state.modal.show
      },
      set(value) {
        if (!value) {
          this.CLOSE_MODAL()
        }
      }
    }
  },
  methods: {
    ...mapMutations('modal', ['CLOSE_MODAL']),
    onHidden() {
      this.CLOSE_MODAL()
    }
  }
}
</script>
